import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { navigate } from "@reach/router";
import DNDUpload from "pages/dashboard/admin/import/interest_imports/components/dnd-upload";
import { csvPreprocessor, onUploadCSV } from "pages/dashboard/admin/import/interest_imports/components/utils";
import { fields } from "pages/dashboard/admin/import/interest_imports/fields";
import { initialStepData, StepData, StepProps } from "..";
import { useStepData } from "../context";
import StepLayout from "./layout";

const getUploadProcessor =
  (payload: StepData, setPayload: React.Dispatch<React.SetStateAction<StepData>>) =>
    onUploadCSV((result, file) => {
      const preprocessed = csvPreprocessor({ ...payload, file, data: result.data });

      // When the header names match our own field names exactly, populate
      // the mapping field ahead of time.
      const [candidate] = preprocessed.data;
      if (!candidate) {
        throw new Error("insufficient data to derive headers from.");
      }

      const mapping = Object.entries(fields).reduce(
        (memo, [key]) => {
          const heading = Object.keys(candidate).find(record => record.trim() === key);

          return (heading ? { ...memo, [heading]: { field: key, format: "" } } : memo);
        },
        {},
      );

      setPayload({ ...preprocessed, mapping });
    });

const StepUpload: React.FC<StepProps> = () => {
  const { stepData, setStepData, setStepName } = useStepData();
  const [files, setFiles] = useState<File[]>(stepData.file ? [stepData.file] : []);
  const params = new URLSearchParams(window.location.search);
  const resetData = params.get("reset");

  useEffect(() => {
    if (resetData) {
      // Resetting the step data and files:
      setFiles([]);
      setStepData(initialStepData);
      navigate("./upload", { replace: true });
    }
  }, []);


  useEffect(() => {
    if (!resetData) {
      setStepData((prevData: StepData) => {
        // Check if file has changed or if files are empty
        if (prevData.file !== files[0] || files.length === 0) {
          return ({
            ...prevData, file: files[0] || null, files, data: [], mapping: {}, problems: [],
          });
        }
        return ({ ...prevData, file: files[0] || null, files });
      });
    }
  }, [files]);

  useEffect(() => {
    if (files.length) {
      const processor =
        getUploadProcessor(stepData, setStepData);
      processor([files[0]]);
    }

  }, [files]);

  useEffect(() => {
    setStepName("Upload");
  }, []);

  return <StepLayout title="Upload a File" description={<Typography variant="body1">Ensuring your file is formatted correctly helps eliminate errors and makes the import process go<br/> smoother and faster.</Typography>}>
    <Grid item xs={12}>
      <DNDUpload setFiles={setFiles} files={files} />
    </Grid>
  </StepLayout>;
};

export default StepUpload;
